import React from "react";

export default function Navbar({
  view,
  onNavigate,
  onAuthClick,
  isLoggedIn,
  userEmail,
}) {
  return (
    <nav className="navbar">
      <div className="navbar-column navbar-column--left" aria-hidden="true" />
      <div className="navbar-column navbar-brand">Ar+</div>
      <div className="navbar-column navbar-column--right">
        <button
          type="button"
          className={`nav-link ${view === "studio" ? "nav-link--active" : ""}`}
          onClick={() => onNavigate("studio")}
        >
          Create
        </button>
        <button
          type="button"
          className={`nav-link ${view === "dashboard" ? "nav-link--active" : ""}`}
          onClick={() => onNavigate("dashboard")}
        >
          Dashboard
        </button>
        <button
          type="button"
          className={`nav-link ${view === "settings" ? "nav-link--active" : ""}`}
          onClick={() => onNavigate("settings")}
        >
          Settings
        </button>
        <button
          type="button"
          className={`nav-link ${view === "login" ? "nav-link--active" : ""}`}
          onClick={onAuthClick}
          title={isLoggedIn ? userEmail || "Logout" : "Login"}
        >
          {isLoggedIn ? "Logout" : "Login"}
        </button>
      </div>
    </nav>
  );
}
